module.exports = __webpack_public_path__ + "img/system-3.ab0d9f73.png";